import { StyleSheet } from 'aphrodite';
import { background, brandPrimary, darkGrayFontColor, titles } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '400px',
		padding: '20px',
		backgroundColor: background,
	},
	content: {
		textAlign: 'center',
		maxWidth: '500px',
		width: '100%',
	},
	icon: {
		width: '48px',
		height: '48px',
		marginBottom: '16px',
		color: brandPrimary,
	},
	title: {
		fontSize: '24px',
		fontWeight: 600,
		color: titles,
		margin: '0 0 12px 0',
	},
	message: {
		fontSize: '16px',
		lineHeight: '24px',
		color: darkGrayFontColor,
		margin: '0 0 24px 0',
	},
});
